import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import api from '../../utils/api';
import { Award, Download, ArrowRight } from 'lucide-react';

export default function CreateCertificatePage() {
  const { institution } = useAuth();
  const navigate = useNavigate();
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState('');
  const [fieldValues, setFieldValues] = useState({});
  const [requesterName, setRequesterName] = useState('');
  const [requesterEmail, setRequesterEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  useEffect(() => {
    api.get('/templates').then(res => {
      setTemplates(res.data);
      if (res.data.length > 0) setSelectedTemplate(res.data[0].id);
    });
  }, []);

  const currentTemplate = templates.find(t => t.id === selectedTemplate);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post('/certificates/direct', {
        template_id: selectedTemplate,
        field_values: fieldValues,
        requester_name: requesterName,
        requester_email: requesterEmail
      });
      setResult(res.data);
    } catch {
      alert('שגיאה ביצירת האישור');
    } finally {
      setLoading(false);
    }
  };

  if (result) {
    return (
      <div style={{maxWidth:480, margin:'60px auto', textAlign:'center'}}>
        <div className="card">
          <div style={{width:64, height:64, background:'#dcfce7', borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 20px'}}>
            <Award size={32} color="var(--success)" />
          </div>
          <h2 style={{marginBottom:8}}>האישור נוצר בהצלחה</h2>
          <p style={{color:'var(--text-muted)', marginBottom:24}}>המסמך מוכן להורדה</p>
          <div style={{display:'flex', gap:12, justifyContent:'center'}}>
            <a className="btn btn-primary" href={result.download_url} target="_blank" rel="noreferrer">
              <Download size={16} /> הורדת האישור
            </a>
            <button className="btn btn-secondary" onClick={() => setResult(null)}>
              אישור נוסף
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{maxWidth:600, margin:'0 auto'}}>
      <div className="page-header" style={{display:'flex', alignItems:'center', gap:12}}>
        <button className="btn btn-secondary" onClick={() => navigate('/dashboard')}>
          <ArrowRight size={16} />
        </button>
        <div>
          <h1>יצירת אישור</h1>
          <p>מילוי ידני מהממשק</p>
        </div>
      </div>

      <div className="card">
        <form onSubmit={handleSubmit}>
          {/* בחירת תבנית */}
          <div className="form-group" style={{marginBottom:16}}>
            <label className="label">תבנית</label>
            <select className="input" value={selectedTemplate} onChange={e => { setSelectedTemplate(e.target.value); setFieldValues({}); }}>
              {templates.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
            </select>
          </div>

          {/* פרטי המבקש */}
          <div className="grid-2" style={{marginBottom:16}}>
            <div>
              <label className="label">שם מלא</label>
              <input className="input" value={requesterName} onChange={e => setRequesterName(e.target.value)} placeholder="ישראל ישראלי" required />
            </div>
            <div>
              <label className="label">מייל (אופציונלי)</label>
              <input className="input" type="email" value={requesterEmail} onChange={e => setRequesterEmail(e.target.value)} placeholder="israel@example.com" />
            </div>
          </div>

          {/* שדות התבנית */}
          {currentTemplate?.fields?.length > 0 && (
            <div style={{borderTop:'1px solid var(--border)', paddingTop:16, marginBottom:16}}>
              <h4 style={{fontSize:13, fontWeight:600, marginBottom:12, color:'var(--text-muted)'}}>שדות האישור</h4>
              <div style={{display:'flex', flexDirection:'column', gap:12}}>
                {currentTemplate.fields.map(field => (
                  <div key={field.id}>
                    <label className="label">{field.label}{field.required && ' *'}</label>
                    <input
                      className="input"
                      type={field.type === 'date' ? 'date' : field.type === 'number' ? 'number' : 'text'}
                      value={fieldValues[field.id] || ''}
                      onChange={e => setFieldValues({...fieldValues, [field.id]: e.target.value})}
                      required={field.required}
                    />
                  </div>
                ))}
              </div>
            </div>
          )}

          <button className="btn btn-primary btn-full" type="submit" disabled={loading}>
            <Award size={16} /> {loading ? 'יוצר אישור...' : 'יצירת אישור'}
          </button>
        </form>
      </div>
    </div>
  );
}
